module.exports = __webpack_public_path__ + "static/media/ic-notif-prohibition-obligation.abc72ec1.svg";